import config from "@/const/config.js";
// 配件判断，因为多处用到，所以抽成公共判断
export const partsJudge = (parts) => {
  if (!parts) {
    return "";
  }
  const formatParts = parts?.trim();
  return ["无", "无配件"].includes(formatParts) ? "" : `有配件: ${formatParts}`;
};

/**
 * 跳转到商城页面
 * @param url
 */
export const navOsPage = (url) => {
  const host =
    process.env.NODE_ENV === "test" || process.env.NODE_ENV === "development"
      ? localStorage.getItem("osHost") || config.osHost
      : config.osHost;
  window.open(`${host}${/^\//.test(url) ? "" : "/"}${url}`);
};

export default {
  partsJudge,
};



// WEBPACK FOOTER //
// ./src/utils/common.js